<template lang="pug">
.indicator_tab.d-flex.flex-column.align-items-center(
  :class="{ selected: selected }"
)
  img.i_mtb_sm_2.i_mlr_sm_3(:src="tabContent.ProductIcon")
  h5.text-center.i_mt_2.i_mt_sm_0 {{ tabContent.ProductNickName }}
</template>

<script>
import MediaImg from "@/components/common/MediaImg";

export default {
  name: "IndicatorTab",
  components: {
    "media-img": MediaImg,
  },
  props: {
    tabContent: Object,
    selected: Boolean,
  },
  data() {
    return {
      // selected: Boolean,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/indicator_tab";
</style>
